/* eslint-disable no-underscore-dangle */

'use strict';

define('vb/private/stateManagement/router/vbRouterState',[], () => {
  /**
   * @typedef {import('vb/private/stateManagement/router/vbRouter').default} VbRouter
   */

  const stateParamExp = /^{(\w+)}$/;

  class VbRouterState {
    /**
     * Constructs a new instance.
     *
     * @param {String}  id
     * @param {Object}  options
     * @param {VbRouter} router
     */
    constructor(id, options, router) {
      if (!id) {
        throw new Error('An id is required when creating a RouterState object.');
      }
      if (!router) {
        throw new Error('A Router is required when creating a RouterState object.');
      }

      // The id is in the form /aaa/{p1}/{p2}
      const path = id.trim().split('/');
      // We cannot have duplicate because the format of the object parameter
      // doesn't allow it.
      /**
       * @package
       * @type {string}
       */
      this._id = path.shift() || '';

      this._parameters = {};

      this._paramOrder = [];

      path.forEach((pathItem, i) => {
        /*
         * Match pattern "{token}"
         */
        const match = pathItem.match(stateParamExp);
        if (match) {
          const token = match[1];
          this._parameters[token] = null;
          this._paramOrder[i] = token;
        }
      }, this);

      this._canEnter = options && options.canEnter;

      this._enter = options && options.enter;

      this._canExit = options && options.canExit;

      this._exit = options && options.exit;

      this._value = options && options.value;

      this._label = options && options.label;

      this._title = options && options.title;

      this._router = router;

      /**
       * @type {Object}
       */
      this.viewModel = undefined;
    }

    go() {
      return this._router.go(this._id);
    }

    isCurrent() {
      return this._router._stateId() === this._id;
    }

    get id() {
      return this._id;
    }

    get value() {
      return this._value;
    }

    get label() {
      return this._label;
    }

    set label(newValue) {
      this._label = newValue;
    }

    get title() {
      return this._title;
    }

    set title(newValue) {
      this._title = newValue;
    }

    get parameters() {
      return this._parameters;
    }
  }

  return VbRouterState;
});

